import { create } from 'zustand';

export type UserFakeIdStore = {
  removeUser: () => void;
  setUser: (user: string) => void;
  user: string | null;
};

export const useUserFakeIdStore = create<UserFakeIdStore>((set) => ({
  user: null,
  setUser: (id: string) => set({ user: id }),
  removeUser: () => set({ user: null }),
}));
